<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="1000"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row :gutter="32">
                    <Divider orientation="left" class="text-primary">合作商权限设置</Divider>
                    <Col span="24">
                        <FormItem label="合作项目" prop="auth_project">
                            <Select v-model="Forms.auth_project" multiple clearable filterable  placeholder="业务员">
                                <Option v-for="(item,index) in projectList" :key="index" :value="item.project_id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目报销" prop="auth_expense">
                            <Checkbox v-model="Forms.auth_expense" :true-value="1" :false-value="0">允许报销</Checkbox>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="允许审批" prop="auth_examine">
                            <Checkbox v-model="Forms.auth_examine" :true-value="1" :false-value="0">允许审批</Checkbox>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">保存设置</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {getPartnerDetail, setAuthData} from "@/apis/partner";
import {getProjectSelectList} from "@/apis/project";

export default {
    name: 'PartnerAuth',
    components: {
    },
    data () {
        return {
            title : '合作商权限',
            isBox : false,
            projectList: [],

            Forms: {
                partner_id: '',
                auth_project: [],
                auth_expense: 0,
                auth_examine: 0
            },
            Rules : {
            },
        }
    },
    methods: {
        /**
         功能：
         time: 2025/12/16 11:12
         **/
        getConfig(){
            let that = this;
            getProjectSelectList().then(e=>{
                that.projectList = e.data ?? [];
            })
        },

        /**
         功能：
         time: 2025/12/16 11:12
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    setAuthData(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025/12/16 11:13
         **/
        show(partner_id){
            this.isBox = true;
            if(partner_id){
                this.Forms.partner_id = partner_id;
                this.GetDetail(partner_id);
            }
            this.getConfig();
        },
        GetDetail(partner_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getPartnerDetail(partner_id).then(e => {
                that.Forms.auth_project = e.data.auth_project ?? [];
                that.Forms.auth_expense = e.data.auth_expense ?? 0;
                that.Forms.auth_examine = e.data.auth_examine ?? 0;
            })
        },
        /**
         功能：
         time: 2025/12/16 11:15
         **/
        FormReset(){
            this.isBox = false;
            this.projectList = [];
            this.$refs['Forms'].resetFields();
            this.Forms.partner_id = '';
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

</style>
